import SimpleEventer from "simple-eventer";
import scrollbarWidth from "../utils/scroll-bar-width";

let currentButtonBoxOpen = null;

export default class ButtonBox extends SimpleEventer {
  constructor($box, $buttons) {
    super();
    this.$buttons = $buttons;
    this.$box = $box;
    this.$currentButton = null;

    this.sizes = null;
    this.isOpen = false;

    this.init();
  }

  init() {
    this.initSizes();
    this.initClick();
  }

  initSizes() {
    window.addEventListener("resize", () => {
      if (this.$currentButton) {
        this.updateSizes();
        this.updateStyles();
      }
      if (this.isOpen) {
        this.close();
      }
    });
  }

  initClick() {
    this.$buttons.forEach(($button) => {
      $button.addEventListener("click", () => {
        if (!this.isOpen) {
          this.updateCurrentButton($button);
          this.updateSizes();
          this.updateStyles();
          this.open();
          this.fire("open");
        } else {
          this.close();
          this.fire("close");
        }
      });
    });
  }

  updateCurrentButton($button) {
    this.$currentButton = $button;
  }

  updateSizes() {
    const buttonRect = this.$currentButton.getBoundingClientRect();

    this.sizes = {
      windowWidth: window.innerWidth,
      scrollWidth: scrollbarWidth(),
      top: buttonRect.top,
      left: buttonRect.x,
      right: window.innerWidth - (buttonRect.x + buttonRect.width),
      height: buttonRect.height,
    };
  }

  updateStyles() {
    if (!this.isOpen) {
      const { windowWidth, scrollWidth, top, left, right, height } = this.sizes;

      if (left > right) {
        this.$box.style.left = "auto";
        this.$box.style.right = windowWidth - left - scrollWidth + "px";
      } else {
        this.$box.style.left = windowWidth - right + "px";
        this.$box.style.right = "auto";
      }

      this.$box.style.top = top + "px";
      this.$box.style.height = height + "px";
    }
  }

  open() {
    this.$box.classList.add("open");
    this.isOpen = true;

    if (currentButtonBoxOpen) {
      currentButtonBoxOpen.close();
    }

    currentButtonBoxOpen = this;
  }

  close() {
    this.$box.classList.remove("open");
    this.isOpen = false;

    currentButtonBoxOpen = null;
  }
}
